import BaseRepository from '../Base/BaseRepository';
import TableEntity    from 'Domain/Model/TableEntity/TableEntity';


class TableRepository extends BaseRepository {

  updateTableConfig(updateConfig) {
    return this.makeRequest({
      path: `/${this.baseRoute}/update`,
      type: 'PATCH',
      data: { config: updateConfig },
      callback: this.initializeSingleModel
    });
  }

  updateColumnConfig(tableEntryId, updateConfig) {
    return this.makeRequest({
      path: `/${this.baseRoute}/update/${tableEntryId}/columns`,
      type: 'PATCH',
      data: { config: updateConfig },
      callback: this.initializeSingleModel
    });
  }


  findUserTableConfig(tableKey) {
    return this.makeRequest({
      path: `/${this.baseRoute}/user/columns`,
      type: 'GET',
      data: {
        tableKey
      },
      callback: (response) => response.tableColumns
    });
  }


}

export default new TableRepository({
  model: TableEntity,
  baseRoute: 'table-config',
  singular: 'tableEntry',
  plural: 'tableEntries',
});
